<template>
  <div class="container-fluid autenticacao">
    <div
      class="card autenticacao-card autenticacao-card--credenciamento"
      :class="{ 'autenticacao-card--etapa2': etapa === 2 }"
    >
      <div class="card-header">
        <div class="card-header-content">
          <div class="card-title-group">
            <div class="card-icon-badge">
              <i class="pi pi-id-card"></i>
            </div>
            <div>
              <h5 class="panel-title">Solicitação de Credenciamento</h5>
              <p class="panel-subtitle">Cadastre sua empresa ou solicite acesso para emissão de notas fiscais</p>
            </div>
          </div>
        </div>
      </div>
      <div id="topo" class="card-body">
        <ContribuinteVinculoCadastro />

        <!-- Stepper Visual de Etapas -->
        <div class="wizard-stepper">
          <div class="wizard-step" :class="{ 'wizard-step--active': etapa === 1, 'wizard-step--completed': etapa > 1 }">
            <span class="wizard-step-circle">
              <i class="pi pi-check" v-if="etapa > 1"></i>
              <span v-else>1</span>
            </span>
            <span class="wizard-step-title">1. Identificação</span>
          </div>
          <div class="wizard-step-line" :class="{ 'wizard-step-line--completed': etapa > 1 }"></div>
          <div class="wizard-step" :class="{ 'wizard-step--active': etapa === 2 }">
            <span class="wizard-step-circle">2</span>
            <span class="wizard-step-title">2. Dados Cadastrais</span>
          </div>
        </div>

        <error-list class="text-left" :erros="erros" />

        <template v-if="etapa == 1">
          <div class="etapa1-form-container">
            <div class="form-group-modern">
              <label for="tipoTomador" class="form-label-modern">Tipo de Contribuinte: *</label>
              <Dropdown
                @change="selecaoTipo()"
                v-model="selectedTipoContribuinte"
                :options="tiposContribuinte"
                optionLabel="name"
                placeholder="Selecione um Tipo de Contribuinte"
                class="dropdown-modern"
              />
            </div>

            <div class="form-group-modern">
              <label for="tipoTomador" class="form-label-modern">
                {{ this.selectedTipoContribuinte.key == 'J' || this.selectedTipoContribuinte.key == 'A' || this.selectedTipoContribuinte.key == 'B' ? 'CNPJ: *' : 'CPF: *' }}
              </label>
              <template v-if="selectedTipoContribuinte.key == 'J' || selectedTipoContribuinte.key == 'A' || selectedTipoContribuinte.key == 'B'">
                <InputMask
                  @blur="validarDocumento()"
                  v-model="documento"
                  key="J"
                  id="tipoTomador"
                  mask="**.***.***/****-99"
                  placeholder="00.000.000/0000-00"
                  class="input-modern"
                  style="text-transform: uppercase;"
                />
              </template>
              <template v-else>
                <InputMask
                  @blur="validarDocumento()"
                  v-model="documento"
                  key="F"
                  id="tipoTomador"
                  mask="999.999.999-99"
                  placeholder="000.000.000-00"
                  class="input-modern"
                />
              </template>
            </div>

            <div class="form-group-modern" v-if="!disablePmunic">
              <label class="form-label-section">Pertence ao Município?</label>
              <div class="radio-pill-group">
                <label class="radio-pill-item" :class="{ active: pertenceMunicipio === 'S' }">
                  <RadioButton
                    id="radio1"
                    :disabled="disablePmunic"
                    name="pertenceMunicipio"
                    value="S"
                    v-model="pertenceMunicipio"
                    tabindex="1"
                    @change="verificarPertenceMunicipio()"
                  />
                  <span>Sim</span>
                </label>
                <label class="radio-pill-item" :class="{ active: pertenceMunicipio === 'N' }">
                  <RadioButton
                    id="radio2"
                    :disabled="disablePmunic"
                    name="pertenceMunicipio"
                    value="N"
                    v-model="pertenceMunicipio"
                    tabindex="2"
                    @change="verificarPertenceMunicipio()"
                  />
                  <span>Não</span>
                </label>
              </div>
              <small class="p-error d-block mt-2" v-if="isPessoaFisicaForaInvalido">
                Para Pessoa Física fora do município, selecione o Tipo de Contribuinte "Pessoa Física (Nota Avulsa)".
              </small>
            </div>
          </div>
        </template>

        <template v-else-if="etapa == 2">
          <div class="container-fluid p-0 text-left">
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label-modern">CPF/CNPJ: *</label>
                <span class="p-fluid">
                  <inputText v-model="solicitacaoCadastro.numDocContribuinte" type="text" disabled />
                </span>
              </div>

              <div class="col-md-8 mb-3">
                <label class="form-label-modern">Nome / Razão Social: *</label>
                <span class="p-fluid">
                  <inputText
                    v-model="solicitacaoCadastro.nomeContribuinte"
                    type="text"
                    :disabled="desabilitarEdicaoEconomico"
                  />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label-modern">Inscrição Municipal:</label>
                <span class="p-fluid">
                  <inputText
                    v-model="solicitacaoCadastro.inscricaoMunicipal"
                    type="text"
                    :disabled="desabilitarEdicaoEconomico || desabilitaInscricaoMunic"
                  />
                </span>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label-modern">CEP: *</label>
                <span class="p-fluid">
                  <div class="p-inputgroup">
                    <InputMask
                      @blur="searchLocalidadePorCep()"
                      v-model="solicitacaoCadastro.cep"
                      mask="99.999-999"
                      placeholder="Pesquisar CEP"
                      :disabled="desabilitarEdicaoEconomico"
                    />
                    <Button
                      @click="searchLocalidadePorCep()"
                      type="button"
                      icon="pi pi-search"
                      class="p-button"
                      title="Pesquisar CEP"
                      :disabled="desabilitarEdicaoEconomico"
                    />
                  </div>
                </span>
              </div>

              <div class="col-md-4 mb-3">
                <label class="form-label-modern" for="munic">Município: *</label>
                <span class="p-fluid">
                  <AutoComplete
                    id="munic"
                    v-model="selectedMunicipio"
                    :dropdown="true"
                    :suggestions="filteredLocalidades"
                    @item-select="setLocalidades($event)"
                    @complete="searchLocalidade($event)"
                    field="detail"
                    placeholder="Pesquisar Município"
                    :disabled="desabilitarEdicaoEconomico"
                  />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3 mb-3">
                <label class="form-label-modern">Estado:</label>
                <span class="p-fluid">
                  <inputText v-model="nomeEstado" type="text" disabled />
                </span>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label-modern">País:</label>
                <span class="p-fluid">
                  <inputText v-model="nomePais" type="text" disabled />
                </span>
              </div>

              <div class="col-md-6 mb-3">
                <label class="form-label-modern">Bairro: *</label>
                <span class="p-fluid">
                  <template v-if="selectedTipoContribuinte.key == 'N' || selectedTipoContribuinte.key == 'A' || selectedTipoContribuinte.key == 'B' || pertenceMunicipio == 'N'">
                    <AutoComplete
                      id="bairr"
                      v-model="selectedBairro"
                      :dropdown="true"
                      :suggestions="filteredBairros"
                      @item-select="setBairro($event)"
                      @complete="searchBairro($event)"
                      field="nomeBairro"
                      placeholder="Pesquisar Bairro"
                      :disabled="desabilitarEdicaoEconomico"
                    />
                  </template>
                  <template v-else>
                    <inputText
                      v-model="solicitacaoCadastro.bairro"
                      type="text"
                      :disabled="desabilitarEdicaoEconomico"
                    />
                  </template>
                </span>
              </div>
            </div>

            <div class="row">
              <template v-if="selectedTipoContribuinte.key == 'N' || selectedTipoContribuinte.key == 'A' || selectedTipoContribuinte.key == 'B'">
                <div class="col-md-7 mb-3">
                  <label class="form-label-modern">Logradouro: *</label>
                  <span class="p-fluid">
                    <AutoComplete
                      id="logra"
                      v-model="selectedLogradouro"
                      :dropdown="true"
                      :suggestions="filteredLogras"
                      @item-select="setLogradouro($event)"
                      @complete="searchLogradouro($event)"
                      placeholder="Pesquisar Logradouro"
                      field="detail"
                      :disabled="desabilitarEdicaoEconomico"
                    >
                      <template #item="slotProps">
                        <div class="p-fluid" style="max-width: 50vw">
                          {{ slotProps.item.detail }}
                        </div>
                      </template>
                    </AutoComplete>
                  </span>
                </div>
              </template>
              <template v-else>
                <div class="col-md-3 mb-3">
                  <label class="form-label-modern">Tipo Logradouro: *</label>
                  <span class="p-fluid">
                    <inputText
                      v-model="solicitacaoCadastro.tipoLogra"
                      type="text"
                      :disabled="desabilitarEdicaoEconomico"
                      maxlength="10"
                    />
                  </span>
                </div>

                <div class="col-md-4 mb-3">
                  <label class="form-label-modern">Logradouro: *</label>
                  <span class="p-fluid">
                    <inputText
                      v-model="solicitacaoCadastro.logradouro"
                      type="text"
                      :disabled="desabilitarEdicaoEconomico"
                    />
                  </span>
                </div>
              </template>

              <div class="col-md-2 mb-3">
                <label class="form-label-modern">Número: *</label>
                <span class="p-fluid">
                  <inputText
                    v-model="solicitacaoCadastro.numero"
                    type="text"
                    :disabled="desabilitarEdicaoEconomico"
                  />
                </span>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label-modern">Complemento:</label>
                <span class="p-fluid">
                  <inputText
                    v-model="solicitacaoCadastro.complemento"
                    type="text"
                    :disabled="desabilitarEdicaoEconomico"
                    maxlength="40"
                  />
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label-modern">E-mail: *</label>
                <span class="p-fluid">
                  <inputText v-model="solicitacaoCadastro.email" type="text" :disabled="desabilitarEdicaoEmail" />
                </span>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label-modern">Telefone:</label>
                <span class="p-fluid">
                  <InputMask
                    v-model="solicitacaoCadastro.contato"
                    mask="(99) 9999-9999"
                    :disabled="desabilitarEdicaoEconomico"
                  />
                </span>
              </div>

              <div class="col-md-3 mb-3">
                <label class="form-label-modern">Celular:</label>
                <span class="p-fluid">
                  <InputMask
                    v-model="solicitacaoCadastro.contatocelular"
                    mask="(99) 99999-999?9"
                    :disabled="desabilitarEdicaoEconomico"
                  />
                </span>
              </div>
            </div>

            <template v-if="exibirCampoSenha">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label-modern">Senha: *</label>
                  <span class="p-fluid">
                    <inputText
                      v-model="solicitacaoCadastro.senha"
                      type="password"
                      autocomplete="off"
                      :disabled="desabilitarEdicaoCampos"
                    />
                  </span>
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label-modern">Confirme a Senha: *</label>
                  <span class="p-fluid">
                    <inputText
                      v-model="solicitacaoCadastro.senhaConfirma"
                      type="password"
                      autocomplete="off"
                      :disabled="desabilitarEdicaoCampos"
                    />
                  </span>
                </div>
              </div>
            </template>

            <template v-if="showLogin">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label-modern">Login Gerado: </label>
                  <span class="p-fluid">
                    <inputText
                      v-model="solicitacaoCadastro.numDocContribuinte"
                      type="text"
                      autocomplete="off"
                      :disabled="true"
                    />
                  </span>
                </div>
              </div>
            </template>
          </div>
        </template>

        <!-- Ações do Formulário (Uma única barra padronizada) -->
        <div class="form-actions-modern" v-if="!sistemaBloqueado">
          <!-- Ações da Etapa 1 -->
          <template v-if="etapa === 1">
            <Button
              label="Voltar ao Login"
              type="button"
              class="btn-modern-secondary"
              @click="login()"
              icon="pi pi-arrow-left"
              :disabled="loading"
            />
            <Button
              label="Avançar"
              type="button"
              class="btn-modern-primary"
              @click="avancarCredenciamento()"
              icon="pi pi-arrow-right"
              :disabled="loading || !documento || isPessoaFisicaForaInvalido"
            />
          </template>

          <!-- Ações da Etapa 2 -->
          <template v-else-if="etapa === 2">
            <Button
              label="Voltar para Etapa 1"
              type="button"
              class="btn-modern-secondary"
              @click="voltarCredenciamento()"
              icon="pi pi-arrow-left"
              :disabled="loading"
            />
            <Button
              label="Solicitar Credenciamento"
              type="button"
              class="btn-modern-primary"
              @click="solicitarCredenciamento(true)"
              icon="pi pi-check"
              :disabled="loading"
              v-if="!desabilitarEdicaoCampos"
            />
          </template>
        </div>

          <div class="copyright">
            <!-- © {{ this.anoAtual }} - GPI - Gestão Pública Integrada -->
          </div>
        </div>

        <Dialog
          class="tomador-modal"
          header="Seleção de Contribuinte"
          :visible.sync="showSelecaoContribuinte"
          :modal="true"
          :closable="false"
        >
          <h1 class="titulo-header">
            Seleção de Contribuinte
            <Button
              id="icon-close-modals"
              icon="pi pi-times"
              class="p-button-rounded p-button-text"
              @click="showSelecaoContribuinte = false"
            />
          </h1>
          <hr />
          <div class="container scrolable-dialog selecao-contribuinte">
            <div class="row">
              <DataTable :value="contribuintes" :paginator="true" :rows="5" style="min-width: 100%">
                <Column headerStyle="width: 30%" field="idPessoa.nomeGeral" header="Nome:"></Column>
                <Column headerStyle="width: 20%" field="idPessoa.numeroDocumentoJuridico" header="CPF/CNPJ:"></Column>
                <Column headerStyle="width: 15%" field="inscricaoMunicipal" header="Inscrição Municipal:"></Column>
                <Column headerStyle="width: 25%" field="detailEndereco" header="Endereço:"></Column>
                <Column headerStyle="width: 58px" bodyStyle="text-align: center">
                  <template #body="objeto">
                    <Button
                      type="button"
                      icon="pi pi-check"
                      title="Selecionar Contribuinte"
                      @click="preencherDadosContribuinte(objeto.data)"
                    ></Button>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
          <hr />
          <div class="container" style="padding: 0px;">
            <div class="row">
              <div>
                <Button
                  @click="hideSelecaoContribuinte()"
                  type="button"
                  label="Fechar"
                  class="p-button-primary mr-2 p-button-danger"
                  icon="pi pi-times"
                />
              </div>
            </div>
          </div>
        </Dialog>
        <Dialog
          header="Impressão Termo de Credenciamento"
          :visible.sync="showTermo"
          :style="{ width: '30vw' }"
          :modal="true"
        >
          <h1 class="titulo-header">
            Impressão Termo de Credenciamento
            <Button
              id="icon-close-modals"
              icon="pi pi-times"
              class="p-button-rounded p-button-text"
              @click="showTermo = false"
            />
          </h1>
          <hr />
          A Solicitação de Credenciamento foi enviada para análise! Deseja imprimir o Termo de Credenciamento?
          <hr />
          <div class="container">
            <div class="row">
              <div>
                <Button label="Sim" icon="pi pi-check" @click="imprimirTermoCredenciamento" class="mr-2" />
                <Button label="Não" icon="pi pi-times" @click="closeTermo" class="p-button-secondary" />
              </div>
            </div>
          </div>
        </Dialog>
        <Dialog header="Seleção Endereço" :visible.sync="showSelectLogra" :modal="true" :closable="false">
          <h1 class="titulo-header">
            Seleção Endereço
            <Button
              id="icon-close-modals"
              icon="pi pi-times"
              class="p-button-rounded p-button-text"
              @click="showSelectLogra = false"
            />
          </h1>
          <hr />
          <div class="container scrolable-dialog selecao-contribuinte" style="padding: 0px;">
            <div class="row">
              <DataTable :value="logradouroList" :paginator="true" :rows="5" style="min-width: 100%">
                <Column field="vwCepLogradouro.detail" header="Endereço:"></Column>
                <Column headerStyle="width: 58px" bodyStyle="text-align: center">
                  <template #body="objeto">
                    <Button
                      type="button"
                      icon="pi pi-check"
                      title="Selecionar"
                      @click="preencherDadosLogradouro(objeto.data)"
                    ></Button>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
          <hr />
          <div class="container" style="padding: 0px;">
            <div class="row">
              <div>
                <Button
                  @click="showSelectLogra = false"
                  type="button"
                  label="Fechar"
                  class="p-button-primary mr-2 p-button-danger"
                  icon="pi pi-times"
                />
              </div>
            </div>
          </div>
        </Dialog>
      </div>

    <Dialog
      header="Contribuinte já Credenciado"
      :visible.sync="showRecuperarSenhaDialog"
      :modal="true"
      :closable="false"
      :style="{ width: '30vw', minWidth: '400px' }"
    >
      <div class="senha-info" style="margin-top: 15px; text-align: center;">
        <i class="pi pi-exclamation-triangle" style="font-size: 2.2rem; color: #f59e0b; margin-bottom: 15px;"></i>
        <p style="font-size: 15px; color: #495057; line-height: 1.5; margin-bottom: 15px;">
          Este documento já possui um <strong>credenciamento ativo</strong> no sistema.
        </p>
        <p style="font-size: 16px; font-weight: 600; color: #212529; margin-bottom: 0;">
          Deseja recuperar a senha de acesso agora?
        </p>
      </div>
      <div class="botoes-avancar-voltar" style="margin-top: 30px; justify-content: center; gap: 15px;">
        <Button
          label="Não, voltar"
          class="btnVoltar"
          icon="pi pi-times"
          style="min-width: 130px; height: 38px; font-size: 14px; margin: 0;"
          @click="showRecuperarSenhaDialog = false"
        />
        <Button
          label="Sim, Recuperar Senha"
          class="btnAvançar"
          icon="pi pi-check"
          style="min-width: 180px; height: 38px; font-size: 14px; margin: 0;"
          @click="redirecionarParaRecuperacao()"
        />
      </div>
    </Dialog>
  </div>
</template>

<script>
import SolicitacaoCadastroService from '../services/tributario/solicitacao.cadastro.service';
import ContribuinteVinculoCadastro from '../views/ContribuinteVinculoCadastro.vue';
import DnsClienteService from '../services/nfse/dns.cliente.service';
import SolicitacaoCadastro from '../models/tributario/SolicitacaoCadastro';
import AutenticacaoService from '../services/nfse/autenticacao.service';
import SerproService from '../services/nfse/serpro.service';
import ClienteService from '../services/acesso/cliente.service';
import Util from '../Utils/util';
import { CLIENT_ID } from '../Utils/clienteId';

export default {
  components: {
    ContribuinteVinculoCadastro,
  },

  data() {
    return {
      loading: false,
      disablePmunic: false,
      showSelecaoContribuinte: false,
      desabilitarEdicaoEmailQuandoExiste: false,
      erros: [],
      tiposContribuinte: [
        { name: 'Pessoa Jurídica', key: 'J' },
        { name: 'Pessoa Física', key: 'F' },
        { name: 'Pessoa Física (Nota Avulsa)', key: 'N' },
      ],
      desabilitaCredenAvulsaNfse: null,
      desabilitaInscricaoMunic: null,
      habilitaCredenContador: null,
      contribuintes: [],
      solicitacaoCadastro: new SolicitacaoCadastro(),
      selectedTipoContribuinte: null,
      pertenceMunicipio: null,
      documento: null,
      etapa: null,
      selectedMunicipio: null,
      filteredLocalidades: null,
      selectedBairro: null,
      filteredBairros: null,
      selectedLogradouro: null,
      filteredLogras: null,
      showTermo: false,
      showLogin: false,
      idCliente: null,
      anoAtual: null,
      selectedCepLogra: null,
      logradouroList: [],
      showSelectLogra: false,
      disableInscMunic: false,
      credenAutoMunic: null,
      apresentacao: false,
      sistemaBloqueado: false,
      showRecuperarSenhaDialog: false
    };
  },

  mounted() {
    this.$nextTick(() => {
      const el = document.getElementById('tipoTomador');
      if (el) el.focus();
    });
    var d = new Date();
    this.anoAtual = d.getFullYear();
    
    let host = window.location.hostname;
    DnsClienteService.get(host).then(async (dns) => {
      this.dnsCliente = dns;
      if (this.dnsCliente && this.dnsCliente.data && this.dnsCliente.data.idCliente) {
        this.idCliente = this.dnsCliente.data.idCliente;
        if(this.dnsCliente.data.idBolBloquearSistema && this.dnsCliente.data.idBolBloquearSistema === 'S'){
          this.sistemaBloqueado = true;
        }
        this.selecaoTipo(); //carrega permissoes
        SolicitacaoCadastroService.validaCamposDisabled(this.dnsCliente.data.idCliente).then((data) => {
          this.desabilitaCredenAvulsaNfse = data.data.desabilitarPessoaFisicaNfse;
          this.desabilitaInscricaoMunic = data.data.desabilitarInscricaoMunic;
          this.habilitaCredenContador = data.data.habilitarPessoaFisicaContador;
          this.credenAutoMunic = data.data.idBolCredenAutoMunic;
          if (this.desabilitaCredenAvulsaNfse === true) {
            this.tiposContribuinte = [
              { name: 'Pessoa Jurídica', key: 'J' },
              { name: 'Pessoa Física', key: 'F' },
            ];
          } else if (this.desabilitarCredenAvulsaNfse === false) {
            this.tiposContribuinte = [
              { name: 'Pessoa Jurídica', key: 'J' },
              { name: 'Pessoa Física', key: 'F' },
              { name: 'Pessoa Física (Nota Avulsa)', key: 'N' },
            ];
          }

          if (
            this.idCliente === 'e166438f-75c0-4beb-8220-602a145537b6' ||
            this.idCliente === 'ce744068-cc92-479f-bf9d-d88cf4238517'
          ) {
            //valença ou cachoeiro
            this.tiposContribuinte = [
              { name: 'Pessoa Jurídica', key: 'J' },
              { name: 'Pessoa Física', key: 'F' },
            ];
          } else if (
            this.idCliente === '19533831040781681800D2584C905F8A' ||
            this.idCliente === '1AFF9FECC742DED8980F1F08BA1323B9'
          ) {
            //simoes ou barreiras
            this.tiposContribuinte = [
              { name: 'Pessoa Jurídica', key: 'J' },
              { name: 'Pessoa Física (Autônomo)', key: 'F' },
              { name: 'Pessoa Física (Nota Avulsa)', key: 'N' },
            ];
          }

          if (this.habilitaCredenContador === true) {
            this.tiposContribuinte.push({ name: 'Pessoa Física (Contador)', key: 'C' });
          }

          if (this.apresentacao) {
            this.tiposContribuinte.push({ name: 'Emissão Notas Avulsas - PJ Município', key: 'A' });
            this.tiposContribuinte.push({ name: 'Emissão Notas Avulsas - PJ Fora', key: 'B' });
          }
        });
      }
      this.processando(false);
    }, 250);
  },

  created() {
    try {
      const raw = localStorage.getItem('nfse_login_cache') || sessionStorage.getItem('nfse_login_cache');
      if (raw) {
        const cached = JSON.parse(raw);
        if (cached) {
          this.idCliente = cached.idCliente || null;
          this.sistemaBloqueado = !!cached.sistemaBloqueado;
        }
      }
    } catch (e) {
      console.warn(e);
    }
    this.apresentacao = (this.$apresentacao ? this.$apresentacao : false);
    this.limparDados();
    this.limparDadosSolicitacaoCadastro();
    this.pertenceMunicipio = 'S';

    this.selectedTipoContribuinte = this.tiposContribuinte[0];
  },

  methods: {
    selecaoTipo() {
      this.disablePmunic = false;
      /*if (this.idCliente === "fec126ed-d8c2-486e-93e9-dcdd9d6c5416") {
        this.disablePmunic = true;
      }*/
      this.pertenceMunicipio = 'S';
      if (this.selectedTipoContribuinte.key == 'N') {
        this.pertenceMunicipio = 'N';
        this.disablePmunic = true;
      }
      if (this.selectedTipoContribuinte.key == 'A') {
        this.pertenceMunicipio = 'S';
        this.disablePmunic = true;
      }
      if (this.selectedTipoContribuinte.key == 'B') {
        this.pertenceMunicipio = 'N';
        this.disablePmunic = true;
      }
      if (this.selectedTipoContribuinte.key == 'C') {
        this.pertenceMunicipio = 'S';
        this.disablePmunic = true;
      }
      if (this.idCliente === 'ce744068-cc92-479f-bf9d-d88cf4238517' && this.selectedTipoContribuinte.key == 'F') {
        //cachoeiro permite apenas contrs do municipio para declaração adm
        this.pertenceMunicipio = 'S';
        this.disablePmunic = true;
      }
      if (this.idCliente === 'F58DEFAB039A9DB0F91C6B13F7C32A46') {
        //tres coracoes permite apenas contrs do municipio
        this.pertenceMunicipio = 'S';
        this.disablePmunic = true;
      }
      this.limparDados();
    },

    limparDados() {
      this.documento = null;
      this.etapa = 1;
    },

    limparDadosSolicitacaoCadastro() {
      this.solicitacaoCadastro = new SolicitacaoCadastro();
      this.selectedMunicipio = null;
      this.selectedPais = null;
      this.selectedLogradouro = null;
      (this.selectedCepLogra = null), (this.selectedBairro = null);
      this.erros = [];
    },

    limparCamposEndereco() {
      this.solicitacaoCadastro.cep = null;
      this.selectedMunicipio = null;
      this.solicitacaoCadastro.tipoLogra = null;
      this.selectedBairro = null;
      this.selectedLogradouro = null;
    },

    login() {
      this.$router.push('/login').catch(() => {});
    },

    voltarCredenciamento() {
      this.etapa = 1;
    },

    verificarPertenceMunicipio() {
      if (this.isPessoaFisicaForaInvalido) {
        this.$root.$emit(
          'alert:warn',
          'Para Pessoa Física fora do município, o credenciamento deve ser realizado selecionando o Tipo de Contribuinte "Pessoa Física (Nota Avulsa)".'
        );
      }
    },

    avancarCredenciamento() {
      if (this.isPessoaFisicaForaInvalido) {
        this.$root.$emit(
          'alert:warn',
          'Para Pessoa Física fora do município, selecione no Tipo de Contribuinte a opção "Pessoa Física (Nota Avulsa)".'
        );
        return;
      }
      if (this.documento && this.pertenceMunicipio && this.selectedTipoContribuinte && this.idCliente) {
        if (this.validarDocumento()) {
          // Se o usuário apenas voltou à etapa 1 para conferir e o documento não mudou, avança mantendo os dados
          if (
            this.solicitacaoCadastro &&
            this.solicitacaoCadastro.numDocContribuinte === this.documento &&
            this.solicitacaoCadastro.nomeContribuinte
          ) {
            this.etapa = 2;
            return;
          }

          this.processando(true);
          this.limparDadosSolicitacaoCadastro();

          SolicitacaoCadastroService.findAllByTipoCpfCnpj(
            this.idCliente,
            this.pertenceMunicipio,
            this.documento,
            this.selectedTipoContribuinte.key,
          )
            .then(
              (response) => {
                let data = response.data.elements;
                if (
                  this.idCliente === '8051f762-e8f9-487c-b537-4b2ce582c5e9' &&
                  this.selectedTipoContribuinte.key !== 'C'
                ) {
                  this.desabilitaInscricaoMunic = true;
                }
                console.log(data);
                if (this.pertenceMunicipio == 'S' && this.selectedTipoContribuinte.key != 'C') {
                  if (data.length) {
                    this.contribuintes = data;

                    // Se encontrar mais de um cadastro, exibe dialog para selecionar.
                    // Se não, já preenche os dados com o contribuinte encontrado.
                    if (data.length > 1) {
                      this.showSelecaoContribuinte = true;
                    } else {
                      this.preencherDadosContribuinte(this.contribuintes[0]);
                    }
                  } else {
                    this.$root.$emit('alert:warn', 'O Contribuinte informado não possui cadastro no município!');
                  }
                } else {
                  if (data.length) {
                    this.contribuintes = data;

                    this.preencherDadosContribuinte(this.contribuintes[0]);
                  } else {
                    this.solicitacaoCadastro.numDocContribuinte = this.documento;
                    setTimeout(async () => {
                      await SerproService.findByDocumento(this.idCliente, this.documento).then(
                        (response) => {
                          if (response.data.endereco && response.data.endereco.municipio && response.data.endereco.uf) {
                            ClienteService.findById(this.idCliente).then((responseCliente) => {
                              if (responseCliente.data.idCepLocalidade) {
                                let municCliente = responseCliente.data.idCepLocalidade.nomeLocalidade;
                                municCliente = this.removerAcentos(municCliente);
                                let ufCliente = responseCliente.data.idCepLocalidade.estado.siglaEstado;

                                let munic = response.data.endereco.municipio;
                                if (munic && typeof munic === 'string') {
                                  munic = this.removerAcentos(munic);
                                } else if (munic) {
                                  munic = this.removerAcentos(munic.descricao);
                                }
                                let uf = response.data.endereco.uf;

                                if (
                                  this.selectedTipoContribuinte.key != 'N' &&
                                  uf.toLowerCase() === ufCliente.toLowerCase() &&
                                  munic.toLowerCase() === municCliente.toLowerCase()
                                ) {
                                  this.$root.$emit(
                                    'alert:warn',
                                    'Este Documento possui endereço no município de origem ' +
                                      municCliente +
                                      ', não é possível realizar credenciamento para fora do município!',
                                  );
                                } else {
                                  this.preencherDadosSerpro(response.data);
                                  this.desabilitarEdicaoEmailQuandoExiste = true;
                                  this.etapa++;
                                }
                              }
                            });
                          } else if (response.data.nome) {
                            this.solicitacaoCadastro.nomeContribuinte = response.data.nome;
                            this.desabilitarEdicaoEmailQuandoExiste = true;
                            this.etapa++;
                          } else {
                            this.desabilitarEdicaoEmailQuandoExiste = true;
                            this.etapa++;
                          }
                        },
                        (error) => {
                          console.log(error);
                          this.desabilitarEdicaoEmailQuandoExiste = true;
                          this.etapa++;
                        },
                      );
                    }, 250);
                  }
                }
              },
              (error) => {
                let errorMessage = 'Houve um problema ao realizar o Credenciamento!';
                if (error.response) {
                  errorMessage = error.response.data;
                }
                this.$toast.add({
                  severity: 'warn',
                  summary: errorMessage,
                });
              },
            )
            .then(() => {
              this.processando(false);
            });
        }
      }
    },
    removerAcentos(texto) {
      let parsed = texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      return parsed;
    },
    solicitarCredenciamento(returnWindow) {
      const pertence = this.pertenceMunicipio;
      const creden = this.credenAutoMunic;
      const senha = this.solicitacaoCadastro.senha;
      const confirma = this.solicitacaoCadastro.senhaConfirma;
      const notificarErro = (mensagem) => {
        this.$root.$emit('alert:warn', mensagem);
        // return true;
      };

      this.showLogin = false;
      if (!this.solicitacaoCadastro.email || !Util.validarEmail(this.solicitacaoCadastro.email)) {
        this.$root.$emit('alert:warn', 'É necessário informar um endereço de E-mail válido!');
      } else if (((pertence === 'S' && creden === 'S') || this.selectedTipoContribuinte.key == 'A' || this.selectedTipoContribuinte.key == 'B' || this.pertenceMunicipio == 'N') && (!senha || !confirma || senha !== confirma)) {
        const senhaVazia = !senha;
        const confirmaVazia = !confirma;

        if (senhaVazia && confirmaVazia) {
          notificarErro('Os Campos de Senha são de preenchimento obrigatório!');
        } else if (senhaVazia || confirmaVazia) {
          notificarErro('Preencha ambos os campos de Senha e Confirmação.');
        } else if (senha !== confirma) {
          notificarErro('Os campos de Senha e Confirmação não coincidem.');
        }
      } else if (
        this.pertenceMunicipio == 'N' &&
        (!this.selectedBairro || typeof this.selectedBairro.id === 'undefined')
      ) {
        this.$root.$emit(
          'alert:warn',
          'Bairro é um campo de seleção, digite a informação e selecione o registro apresentado na pesquisa!',
        );
      } else if (
        (this.selectedTipoContribuinte.key == 'N' || this.selectedTipoContribuinte.key == 'A' || this.selectedTipoContribuinte.key == 'B') &&
        (!this.selectedLogradouro || typeof this.selectedLogradouro.id === 'undefined')
      ) {
        this.$root.$emit(
          'alert:warn',
          'Logradouro é um campo de seleção, digite a informação e selecione o registro apresentado na pesquisa!',
        );
      } else {
        if (
          returnWindow &&
          this.selectedTipoContribuinte.key === 'J' &&
          this.dnsCliente.data.idCliente === 'ce744068-cc92-479f-bf9d-d88cf4238517'
        ) {
          //9A056422C49DEDE23B222C03E4436321 - testes
          this.processando(false);
          this.$root.$emit('contribuinteVinculo:novo');
        } else {
          this.processando(true);
          this.erros = [];

          //Campos de endereço que podem ser alterados e não estão atrelados diretamente aos campos
          this.solicitacaoCadastro.idCliente = this.idCliente;
          this.solicitacaoCadastro.idCepLocalidade = this.selectedMunicipio ? this.selectedMunicipio.id : '';
          if (this.selectedBairro) {
            this.solicitacaoCadastro.idBairro = this.selectedBairro.id;
            this.solicitacaoCadastro.bairro = this.selectedBairro.nomeBairro;
          } else {
            this.solicitacaoCadastro.idBairro = null;
          }

          if (this.selectedLogradouro && this.selectedLogradouro.id) {
            this.solicitacaoCadastro.idLogradouro = this.selectedLogradouro.id;
            this.solicitacaoCadastro.logradouro = this.selectedLogradouro.nomeLogradouro;
            if (this.selectedLogradouro.idCepTipoLogra && this.selectedLogradouro.idCepTipoLogra.nomeTipoLogra) {
              this.solicitacaoCadastro.tipoLogra = this.selectedLogradouro.idCepTipoLogra.nomeTipoLogra;
            }
          } else {
            this.solicitacaoCadastro.idLogradouro = null;
          }
          if (this.solicitacaoCadastro.tipoLogra === '') {
            this.solicitacaoCadastro.tipoLogra = '.';
          }

          this.solicitacaoCadastro.cidade = this.selectedMunicipio ? this.selectedMunicipio.nomeLocalidade : '';

          this.solicitacaoCadastro.estado =
            this.selectedMunicipio && this.selectedMunicipio.estado ? this.selectedMunicipio.estado.nomeEstado : '';

          this.solicitacaoCadastro.tipoPessoa = this.selectedTipoContribuinte.key;
          this.solicitacaoCadastro.pertenceAoMunicipio = this.pertenceMunicipio == 'S' ? true : false;

          SolicitacaoCadastroService.save(this.solicitacaoCadastro)
            .then(
              (data) => {
                console.log(data.data);
                this.solicitacaoCadastro = data.data;
                const credenciamentoPendente =
                  this.credenAutoMunic != 'S' || !this.solicitacaoCadastro.idBolServicAtivVinc;

                if (
                  ((this.pertenceMunicipio == 'S' && this.solicitacaoCadastro.tipoPessoa != 'C' && this.solicitacaoCadastro.tipoPessoa != 'A') ||
                    (this.solicitacaoCadastro.idBolCredencEventualAceite &&
                      this.solicitacaoCadastro.idBolCredencEventualAceite === 'S') ||
                    (this.pertenceMunicipio == 'N' &&
                      this.solicitacaoCadastro.idBolAnaliseCreden &&
                      this.solicitacaoCadastro.idBolAnaliseCreden === 'S')) &&
                  this.solicitacaoCadastro.tipoPessoa != 'A' && this.solicitacaoCadastro.tipoPessoa != 'B' &&
                  credenciamentoPendente
                ) {
                  this.showTermo = true;
                } else if (this.solicitacaoCadastro.tipoPessoa === 'C' && credenciamentoPendente) {
                  this.showLogin = true;
                  this.$root.$emit(
                    'alert:success',
                    'A Solicitação de Credenciamento foi enviada para análise! Em breve receberá um e-mail com a confirmação do credenciamento!',
                  );
                } else {
                  this.showLogin = true;
                  this.$root.$emit(
                    'alert:success',
                    'O Credenciamento foi efetuado com sucesso! Login gerado: ' +
                      this.solicitacaoCadastro.numDocContribuinte,
                  );
                }
              },
              (error) => {
                const erros = error.response.data;
                if (erros && erros.length && erros.includes('CONTRIBUINTE_JA_CREDENCIADO')) {
                  this.showRecuperarSenhaDialog = true;
                } else {
                  this.erros.push(...erros);

                  if (!erros.length) {
                    this.$root.$emit('alert:error', 'Houve um problema ao solicitar o Credenciamento!');
                  }
                }
              },
            )
            .then(() => {
              this.processando(false);
            });
        }
      }
    },
    setLocalidades(event) {
      this.processando(true);
      if (this.pertenceMunicipio == 'S') {
        this.selectedMunicipio = event.value;
      } else {
        this.selectMunicipioSede(event.value);
      }
    },

    selectMunicipioSede(municipio) {
      this.processando(false);
      if (this.pertenceMunicipio == 'N') {
        //caso não seja do municipio valida se não informou o municipio sede
        ClienteService.findById(this.idCliente)
          .then((responseCliente) => {
            const cliente = responseCliente.data;

            if (this.selectedTipoContribuinte.key === 'F' && this.idCliente === CLIENT_ID.BARREIRAS) {
              const ibgeNovoEndereco = municipio.codigoIbge;
              const ibgeCliente = cliente.idCepLocalidade ? cliente.idCepLocalidade.codigoIbge : null;

              if (ibgeNovoEndereco !== ibgeCliente) {
                this.$root.$emit(
                  'alert:warn',
                  'Para Pessoa Física fora do município, o local do credenciamento deve ser o mesmo do cadastro do cliente.',
                );

                this.limparCamposEndereco();
                this.selectedMunicipio = null;
                return;
              }
            } else if (this.selectedTipoContribuinte.key != 'N') {
              if (responseCliente.data.idCepLocalidade) {
                if (municipio.id == responseCliente.data.idCepLocalidade.id) {
                  this.$root.$emit(
                    'alert:warn',
                    'Não é possível realizar um credenciamento para fora do município utilizando o município sede!',
                  );
                  this.selectedMunicipio = null;
                } else {
                  this.selectedMunicipio = municipio;
                }
              } else {
                this.selectedMunicipio = municipio;
              }
            } else if (this.selectedTipoContribuinte.key === 'N') {
              this.selectedMunicipio = municipio;
            }
          })
          .then(() => {
            this.processando(false);
          });
      } else {
        this.selectedMunicipio = municipio;
      }
    },

    searchLocalidade(event) {
      setTimeout(async () => {
        this.filteredLocalidades = await SolicitacaoCadastroService.findAllByFiltro(event.query);
      }, 250);
    },

    setBairro(event) {
      this.processando(true);
      this.selectedBairro = event.value;
      this.processando(false);
    },

    searchBairro(event) {
      setTimeout(async () => {
        this.filteredBairros = await SolicitacaoCadastroService.findAllBairroByFiltro(this.idCliente, event.query);
      }, 250);
    },

    setLogradouro(event) {
      this.processando(true);
      this.selectedLogradouro = event.value;
      this.processando(false);
    },

    searchLogradouro(event) {
      setTimeout(async () => {
        this.filteredLogras = await SolicitacaoCadastroService.findAllLogradouroByFiltro(this.idCliente, event.query);
      }, 250);
    },

    searchLocalidadePorCep() {
      if (this.solicitacaoCadastro.cep !== '') {
        this.processando(true);
        let cep = this.solicitacaoCadastro.cep;
        cep = cep.replace('.', '');
        cep = cep.replace('-', '');
        SolicitacaoCadastroService.findAllLograByCep(cep, this.idCliente)
          .then(
            (response) => {
              if (response.data.length && response.data.length > 1) {
                this.logradouroList = response.data;
                this.showSelectLogra = true;
              } else if (response.data.length > 0) {
                this.selectedCepLogra = response.data[0];
                this.preencherDadosLogradouro(this.selectedCepLogra);
              }
            },
            (error) => {
              let errorMessage = 'Houve um problema ao listar Logradouros!';
              if (error.response) {
                errorMessage = error.response.data;
              }
              this.$toast.add({
                severity: 'error',
                summary: errorMessage,
              });
            },
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    preencherDadosLogradouro(logradouro) {
      this.processando(true);
      this.selectedBairro = null;
      this.selectedLogradouro = null;
      this.solicitacaoCadastro.cep = logradouro.vwCepLogradouro.cepLogradouro;
      this.solicitacaoCadastro.bairro = logradouro.vwCepLogradouro.nomeBairro;
      this.solicitacaoCadastro.tipoLogra = logradouro.vwCepLogradouro.nomeTipoLogra;
      this.solicitacaoCadastro.logradouro = logradouro.vwCepLogradouro.nomeLogradouro;
      const nomeLogra = this.solicitacaoCadastro.tipoLogra + ' ' + this.solicitacaoCadastro.logradouro;
      const bairro = this.solicitacaoCadastro.bairro;
      let idBairro = null;
      let idLogra = null;
      if (logradouro.cepBairro) {
        this.selectedBairro = logradouro.cepBairro;
        idBairro = this.selectedBairro.id;
      }
      if (logradouro.cepLogradouro) {
        this.selectedLogradouro = logradouro.cepLogradouro;
        idLogra = this.selectedLogradouro.id;
      }

      SolicitacaoCadastroService.findAllById(logradouro.vwCepLogradouro.idCepLocalidade)
        .then((response) => {
          this.selectMunicipioSede(response.data, nomeLogra, bairro, idLogra, idBairro);
        })
        .then(() => {
          this.processando(false);
          this.showSelectLogra = false;
        });
    },

    hideSelecaoContribuinte() {
      this.limparDadosSolicitacaoCadastro;
      this.showSelecaoContribuinte = false;
    },

    preencherDadosSerpro(dados) {
      this.solicitacaoCadastro.nomeContribuinte = dados.nome_empresarial ? dados.nome_empresarial : '';
      this.solicitacaoCadastro.nomeContribuinte = dados.nome_empresarial ? dados.nome_empresarial : '';
      this.solicitacaoCadastro.cep = dados.endereco.cep ? dados.endereco.cep : '';
      if (this.solicitacaoCadastro.cep) {
        this.searchLocalidadePorCep();
      }
      this.solicitacaoCadastro.bairro = dados.endereco.bairro ? dados.endereco.bairro : '';
      this.solicitacaoCadastro.cidade = dados.endereco.municipio ? dados.endereco.municipio : '';
      this.solicitacaoCadastro.estado = dados.endereco.uf ? dados.endereco.uf : '';
      this.solicitacaoCadastro.estado = dados.endereco.uf ? dados.endereco.uf : '';
      if (dados.endereco.logradouro) {
        let endereco = dados.endereco.logradouro.split(' ');
        this.solicitacaoCadastro.tipoLogra = endereco[0];
        this.solicitacaoCadastro.logradouro = dados.endereco.logradouro.replace(endereco[0], '');
      }
      this.solicitacaoCadastro.complemento = dados.endereco.complemento ? dados.endereco.complemento : '';
      this.solicitacaoCadastro.numero = dados.endereco.numero ? dados.endereco.numero : '';
    },

    preencherDadosContribuinte(contribuinte) {
      this.hideSelecaoContribuinte();
      this.processando(true);

      SolicitacaoCadastroService.validarPodeCredenciar(
        contribuinte.idPessoa.id,
        contribuinte.idPessoa.numeroDocumentoJuridico,
        contribuinte.inscricaoMunicipal,
        this.pertenceMunicipio,
        this.selectedTipoContribuinte.key,
        this.idCliente,
      )
        .then((data) => {
          this.erros = [];
          const erros = data.data;
          if (erros.length) {
            if (erros[0] === 'CONTRIBUINTE_JA_CREDENCIADO') {
              this.showRecuperarSenhaDialog = true;
              return;
            }
            if (erros[0].includes(';')) {
              let retorno = erros[0].split(';');
              if (retorno != null) {
                this.solicitacaoCadastro.id = retorno[0];
                this.$root.$emit('alert:warn', retorno[1]);
                console.log(retorno[0]);
                this.solicitacaoCadastro.id = retorno[0];
                this.showTermo = true;
                return;
              }
            } else {
              this.erros = erros;
            }
          } else {
            this.solicitacaoCadastro.idContribuinte = contribuinte.id;
            this.solicitacaoCadastro.idPessoa = contribuinte.idPessoa ? contribuinte.idPessoa.id : null;
            this.solicitacaoCadastro.numDocContribuinte = contribuinte.idPessoa.numeroDocumentoJuridico;
            this.solicitacaoCadastro.nomeContribuinte = contribuinte.idPessoa.nomeGeral
              ? contribuinte.idPessoa.nomeGeral.trim()
              : '';
            this.solicitacaoCadastro.inscricaoMunicipal = contribuinte.inscricaoMunicipal;

            this.selectedMunicipio = contribuinte.idLocalidadeMunicipio;
            this.solicitacaoCadastro.cep = contribuinte.cep;

            this.solicitacaoCadastro.bairro = contribuinte.idBairro ? contribuinte.idBairro.nomeBairro.trim() : '';

            this.selectedBairro = contribuinte.idBairro ? contribuinte.idBairro : null;

            this.solicitacaoCadastro.cidade = this.selectedMunicipio ? this.selectedMunicipio.nomeLocalidade : '';

            this.solicitacaoCadastro.estado =
              contribuinte.idLocalidadeMunicipio && contribuinte.idLocalidadeMunicipio.estado
                ? contribuinte.idLocalidadeMunicipio.estado.nomeEstado
                : '';

            this.solicitacaoCadastro.tipoLogra =
              contribuinte.idLogradouro && contribuinte.idLogradouro.idCepTipoLogra
                ? contribuinte.idLogradouro.idCepTipoLogra.nomeTipoLogra.length > 10
                  ? contribuinte.idLogradouro.idCepTipoLogra.nomeTipoLogra.substring(0, 10)
                  : contribuinte.idLogradouro.idCepTipoLogra.nomeTipoLogra
                : '';
            this.solicitacaoCadastro.logradouro = contribuinte.idLogradouro
              ? contribuinte.idLogradouro.nomeLogradouro
              : '';
            this.selectedLogradouro = contribuinte.idLogradouro ? contribuinte.idLogradouro : null;
            this.solicitacaoCadastro.numero = contribuinte.numeroLogradouro;
            this.solicitacaoCadastro.complemento = contribuinte.complementoLogradouro
              ? contribuinte.complementoLogradouro && contribuinte.complementoLogradouro.length > 40
                ? contribuinte.complementoLogradouro.substring(0, 40)
                : contribuinte.complementoLogradouro
              : '';

            this.solicitacaoCadastro.email =
              contribuinte.contatos && contribuinte.contatos.email ? contribuinte.contatos.email.trim() : null;
            this.solicitacaoCadastro.contato = contribuinte.contatos ? contribuinte.contatos.telefone : null;
            this.solicitacaoCadastro.contatocelular = contribuinte.contatos ? contribuinte.contatos.celular : null;

            this.etapa++;

            if (this.pertenceMunicipio == 'S' && this.solicitacaoCadastro.email) {
              this.desabilitarEdicaoEmailQuandoExiste = false;
            } else {
              this.desabilitarEdicaoEmailQuandoExiste = true;
            }

            if (this.pertenceMunicipio == 'S' && this.solicitacaoCadastro.idContribuinte) {
              this.$root.$emit(
                'alert:warn',
                'O contribuinte informado é do Tipo Econômico. Os dados não podem ser alterados.',
              );
            }
          }
        })
        .then(() => {
          this.processando(false);
        });
    },

    redirecionarParaRecuperacao() {
      const doc = this.solicitacaoCadastro.numDocContribuinte || this.documento;
      const tipo = this.selectedTipoContribuinte ? this.selectedTipoContribuinte.key : 'J';
      
      this.$router.push({
        path: '/login',
        query: {
          recover: 'true',
          doc: doc,
          type: tipo
        }
      });
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit('loading:show');
      } else {
        this.loading = false;
        this.$root.$emit('loading:hide');
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documento);

      if (!validar && this.documento) {
        console.log(validar);
        this.$root.$emit('alert:warn', 'CPF/CNPJ inválido!');
      }

      return validar;
    },

    validarSenha() {
      return this.solicitacaoCadastro.senha === this.solicitacaoCadastro.senhaConfirma ? true : false;
    },

    closeTermo() {
      this.showTermo = false;
    },

    imprimirTermoCredenciamento() {
      this.processando(true);
      AutenticacaoService.visualisarTermo(this.solicitacaoCadastro.id)
        .then(
          () => {},
          (error) => {
            this.$root.$emit('alert:warn', 'Erro ao exibir a visualização!');
            console.log(error);
          },
        )
        .then(() => {
          this.processando(false);
        });
    },
  },

  computed: {
    nomeEstado() {
      return this.selectedMunicipio && this.selectedMunicipio.estado ? this.selectedMunicipio.estado.detail : '';
    },

    nomePais() {
      return this.selectedMunicipio && this.selectedMunicipio.estado && this.selectedMunicipio.estado.pais
        ? this.selectedMunicipio.estado.pais.detail
        : '';
    },

    desabilitarEdicaoCampos() {
      return this.solicitacaoCadastro && this.solicitacaoCadastro.id ? true : false;
    },

    desabilitarEdicaoEconomico() {
      return this.desabilitarEdicaoCampos ||
        (this.pertenceMunicipio == 'S' && this.solicitacaoCadastro && this.solicitacaoCadastro.idContribuinte)
        ? true
        : false;
    },

    desabilitarEdicaoEmail() {
      return this.desabilitarEdicaoCampos || !this.desabilitarEdicaoEmailQuandoExiste ? true : false;
    },

    exibirCampoSenha() {
      return this.pertenceMunicipio == 'N' || this.credenAutoMunic == 'S' || this.selectedTipoContribuinte.key == 'A' || this.selectedTipoContribuinte.key == 'B' ? true : false;
    },

    exibirBotao() {
      const botoes = {
        voltar: false,
        avancar: false,
        credenciar: false,
      };

      botoes.voltar = this.etapa > 1;
      botoes.avancar = this.etapa < 2;
      botoes.credenciar = this.etapa == 2 && !this.desabilitarEdicaoCampos;

      return botoes;
    },

    isPessoaFisicaForaInvalido() {
      return (
        this.idCliente === CLIENT_ID.VITORIA_CONQUISTA &&
        this.selectedTipoContribuinte &&
        this.selectedTipoContribuinte.key === 'F' &&
        this.pertenceMunicipio === 'N'
      );
    },
  },

  watch: {
    pertenceMunicipio() {
      this.verificarPertenceMunicipio();
    },
  },
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>
